import React from 'react';
import { IconSizeType } from 'common/constants';
import { UserIconReact } from 'common/widgets/user-icon';
import { UserInfo as UserInfoType } from 'apps/lexicon/src/models/event-definition';
import { ExperimentStatus } from 'apps/experiments/src/components/common/status';
import { ExperimentStatus as ExperimentStatusEnum } from 'apps/experiments/src/types';
import styles from './cell-renderers.module.styl';
type UserInfoArgs = {
  user: UserInfoType;
};
type StatusArgs = {
  status: ExperimentStatusEnum;
  percent?: number;
};
export function UserInfo(_ref: UserInfoArgs) {
  let {
    user
  }: UserInfoArgs = _ref;
  const userIconAttrs = user !== null && user !== void 0 && user.id ? {
    id: user === null || user === void 0 ? void 0 : user.id,
    name: user === null || user === void 0 ? void 0 : user.name,
    email: user === null || user === void 0 ? void 0 : user.email
  } : {};
  return <div className={styles.userInfoField} data-sentry-component="UserInfo" data-sentry-source-file="cell-renderers.tsx">
      <UserIconReact size={IconSizeType.Small} {...userIconAttrs} data-sentry-element="UserIconReact" data-sentry-source-file="cell-renderers.tsx" />
    </div>;
}
export function Status(_ref2: StatusArgs) {
  let {
    status,
    percent
  }: StatusArgs = _ref2;
  return <ExperimentStatus status={status} percent={percent} data-sentry-element="ExperimentStatus" data-sentry-component="Status" data-sentry-source-file="cell-renderers.tsx" />;
}